import { createPrefixedConstants } from 'app/common/CommonUtils';

export default createPrefixedConstants(
  'error',
  `
    ADD_ERROR
    CLEAR_ERROR
    CLEAR_ERRORS
  `
);
